/**
 * Transforms the given font size stored for form styling into a CSS unit.
 *
 * @param {number} value
 * @return {string}
 */
export default (value) => (value != null ? `${value}px` : value);
